import * as HTTP_REQUEST from "./api";
import { handleResponse } from "../utils/functions";
import { ACCESS_TOKEN } from "./auth";

const MODEL_PATH = "/sistema/";

export const getFacultades = async () => {
  const response = await HTTP_REQUEST.get(MODEL_PATH + "facultades");
  return handleResponse(response);
};

export const getSemestres = async () => {
  const response = await HTTP_REQUEST.get(MODEL_PATH + "semestres");
  return handleResponse(response);
};

export const getOficinas = async () => {
  const response = await HTTP_REQUEST.get(MODEL_PATH + "oficinas");
  return handleResponse(response);
};

export const getCondicionesContrato = async () => {
  const response = await HTTP_REQUEST.get(MODEL_PATH + "condicion-contrato");
  return handleResponse(response);
};

export const getDepartamentosAcademicos = async () => {
  const response = await HTTP_REQUEST.get(MODEL_PATH + "dep-academico");
  return handleResponse(response);
};

export const getCarreras = async () => {
  const response = await HTTP_REQUEST.get(MODEL_PATH + "carreras");
  return handleResponse(response);
};

export const getEspecialidades = async () => {
  const response = await HTTP_REQUEST.get(MODEL_PATH + "especialidades");
  return handleResponse(response);
};

export const getAsignaturas = async () => {
  const response = await HTTP_REQUEST.get(MODEL_PATH + "asignaturas");
  return handleResponse(response);
};

export const getGradoAcademico = async () => {
  const response = await HTTP_REQUEST.get(MODEL_PATH + "grado-academicos");
  return handleResponse(response);
};

export const getLugaresExamenes = async () => {
  const response = await HTTP_REQUEST.get(MODEL_PATH + "lugarexamenes");
  return handleResponse(response);
};

export const previewFile = async (type, file) => {
  const response = await HTTP_REQUEST.getFile(
    MODEL_PATH + `view?type=${type}&file=${file}&token=${ACCESS_TOKEN}`
  );
  return response; // return a blob
};

export const downloadPDF = async (archivo) => {
  const response = await HTTP_REQUEST.getFile(MODEL_PATH + "download/" + archivo);
  return response; // return a blob
};

export const getConfig = async () => {
  const response = await HTTP_REQUEST.get(MODEL_PATH + "config");
  return handleResponse(response);
};

export const getAllImportacion = async () => {
  const response = await HTTP_REQUEST.get(`${MODEL_PATH}importacion`);
  return handleResponse(response);
};

export const executeUpdate = async ({ collection, nombreid, valorid }, data) => {
  const response = await HTTP_REQUEST.put(
    `${MODEL_PATH}${collection}/${nombreid}/${valorid}`,
    data
  );
  return handleResponse(response);
};

export const isRequestPasswordEnabled = async () => {
  const response = await HTTP_REQUEST.get(`${MODEL_PATH}is-request-password-enabled`);
  return handleResponse(response);
};
